import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=2d403b36&scoped=true"
import script from "./baseinfo.vue?vue&type=script&lang=js"
export * from "./baseinfo.vue?vue&type=script&lang=js"
import style0 from "./baseinfo.vue?vue&type=style&index=0&id=2d403b36&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d403b36",
  null
  
)

export default component.exports